// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"TabNav-module--tab-nav--2Ejv-","tabNavItem":"TabNav-module--tab-nav-item--2utGm","active":"TabNav-module--active--1U4dE"};